import $ from 'jquery';
import moment from 'moment';

/**
 * Enhances forms with popup calendar
 *
 * @param context
 */
export default function datetimeDirective(context=document.body) {
	const $context = $(context);
	$context.on('focus', 'input.-type-datetime', function() {
		const $input = $(this);
		let time;

		if ($input.next().hasClass('calendar-modal')) {
			return
		}

		let m = moment($input.val().substr(0, 10));

		if (!m.isValid()) {
			m = moment();
		}

		let selected = moment(m);

		$input.addClass('-cal-open');

		const $cal = $(`
			<div class="calendar-modal">
				<div class="cal-container">
					<div class="controls">
						<div class="prev">&larr;</div>
						<div class="month"></div>
						<div class="next">&rarr;</div>
					</div>
					<div class="cal">
						<div class="days">
							<div>S</div>
							<div>M</div>
							<div>T</div>
							<div>W</div>
							<div>T</div>
							<div>F</div>
							<div>S</div>
						</div>
						<div class="dates">
						</div>
					</div>
				</div>
				<div class="time-container">
				</div>
			</div>
		`);

		const $time = $cal.find('.time-container');

		for (let t = 480; t < 1230; t += 30) {
			const h = ((Math.floor(t / 60) + 11) % 12) + 1
			let m = t % 60
			if (m < 10) m = '0' + m
			const a = (t < 720 ? 'am' : 'pm')
			const time = `${h}:${m} ${a}`
			$time.append(`<div class="time">${time}</div>`)
		};

		$time.find('.time').click(function() {
			if (!$input.val()) return
			time = $(this).text();
			$input.val($input.val().substr(0, 10) + ' ' + time);
			$(this).siblings().removeClass('selected');
			$(this).addClass('selected');
		});

		$cal.insertAfter($input);

		$input.on('click focus blur', e => e.stopPropagation());

		$cal.on('click', function(e) {
			return false;
		});

		$context.one('click', () => {
			$cal.remove();
		});

		const $dates = $cal.find('.dates');

		function updateCal() {
			$cal.find('.month').html(
				m.format('MMMM YYYY')
			);

			const month = m.month();
			$dates.find('.date').remove();

			const startOff = m.startOf('month').day()
			let date = moment(m).startOf('month').subtract(startOff, 'days')

			for (let d = 0; d < 42; d++) {
				$dates.append(`
					<div
						class="
							date
							${date.month() !== month ? 'sibling' : ''}
							${date.isSame(selected) ? 'selected' : ''}
						"
						data-date="${date.format('YYYY-MM-DD')}"
					>
						${date.date()}
					</div>
				`)
				date = date.add(1, 'day')
			};
		}

		updateCal();

		$cal.find('.prev').click(() => {
			m = m.subtract(1, 'month');
			updateCal();
		});

		$cal.find('.next').click(() => {
			m = m.add(1, 'month');
			updateCal();
		});

		$dates.on('click', '.date', function(e) {
			$dates.find('.selected').removeClass('selected');
			$(this).addClass('selected');
			$input.val($(this).attr('data-date') + (time ? ' ' + time : ''));
			selected = moment(m);
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/datetime.js